/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} High_Thc_SeedsInputs */

const en_high_thc_seeds = /** @type {(inputs: High_Thc_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High THC Seeds`)
};

const th_high_thc_seeds = /** @type {(inputs: High_Thc_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เมล็ดพันธุ์ THC สูง`)
};

const ja_high_thc_seeds = /** @type {(inputs: High_Thc_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高THCシード`)
};

const fr_high_thc_seeds = /** @type {(inputs: High_Thc_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Graines à THC élevé`)
};

const es_high_thc_seeds = /** @type {(inputs: High_Thc_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semillas con THC alto`)
};

const ru_high_thc_seeds = /** @type {(inputs: High_Thc_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Семена с высоким THC`)
};

const zh_high_thc_seeds = /** @type {(inputs: High_Thc_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高THC种子`)
};

const vi_high_thc_seeds = /** @type {(inputs: High_Thc_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hạt giống THC cao`)
};

/**
* | output |
* | --- |
* | "High THC Seeds" |
*
* @param {High_Thc_SeedsInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const high_thc_seeds = /** @type {((inputs?: High_Thc_SeedsInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<High_Thc_SeedsInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_high_thc_seeds(inputs)
	if (locale === "ja") return ja_high_thc_seeds(inputs)
	if (locale === "fr") return fr_high_thc_seeds(inputs)
	if (locale === "es") return es_high_thc_seeds(inputs)
	if (locale === "ru") return ru_high_thc_seeds(inputs)
	if (locale === "zh") return zh_high_thc_seeds(inputs)
	if (locale === "vi") return vi_high_thc_seeds(inputs)
	return en_high_thc_seeds(inputs)
});